document.addEventListener("DOMContentLoaded", function() {
  (function($) {

       $("#villages-map__hawaii").click(function() {
         scrollToIsland($("#hawaii"));
       });
       $("#villages-map__fiji").click(function() {
         scrollToIsland($("#fiji"));
       });
       $("#villages-map__aotearoa").click(function() {
         scrollToIsland($("#aotearoa"));
       });
       $("#villages-map__samoa").click(function() {
         scrollToIsland($("#samoa"));
       });
       $("#villages-map__tonga").click(function() {
         scrollToIsland($("#tonga"));
       });
       $("#villages-map__tahiti").click(function() {
         scrollToIsland($("#tahiti"));
       });
       $("#villages-map__marquesas").click(function() {
         scrollToIsland($("#marquesas"));
       });
       $(".villages-islands__info-back-icon-link").click(function() {
         scrollToMap();
       });

       $(".villages-islands__main-image, .villages-islands__main-image--mobile").click(openModal);

        $(window).on("closed.zf.reveal", function() {
          $("#villagesModal iframe").attr("src", "");
        })

       function scrollToIsland(element) {
         $("html, body").animate({ scrollTop: element.offset().top - 112 }, 400);
       }

       function scrollToMap() {
         $("html, body").animate({ scrollTop: $(".villages-map__map").offset().top - 112 }, 400);
       }

       function openModal() {
         var iframe = $("#pcc-modal iframe");
         iframe.attr("src", $(this).data("url"));
         iframe.css("left", getImageCenter(iframe[0]));

         function getImageCenter(element) {
           var elWidth = element.clientWidth,
               galleryWidth  = document.getElementsByClassName('pcc-modal__slider')[0].clientWidth
           ;
           return (galleryWidth/2) - (elWidth/2);
         }
       }

       $('.orbit-my-next').click(function(e){
         var orbit = $(this).parents('.orbit');
         var orbits = $(orbit).find('.orbit-slide');
         var index = $(orbit).find('.orbit-slide.is-active').data('slide');
         index++
         if(index == orbits.length - 1){
           index = 0
         }
         $(orbit).find('.orbit-slide.is-active').removeClass('is-active').css('left', '0%').animate(function(){
           left:'100%'
         }, 300, function(){
           $(this).css({
             position:'relative',
             display:'none'
           })
         });
         $(orbit).find('.orbit-slide[data-slide='+index+']').addClass('is-active').css({
           position:'relative',
           display:'',
            left:'-100%'
         }).animate({
           left:'0'
         }, 300);
       });
       $('.orbit-my-previous').click(function(e){
         var orbit = $(this).parents('.orbit');
         var orbits = $(orbit).find('.orbit-slide');
         var index = $(orbit).find('.orbit-slide.is-active').data('slide');
         index--
         if(index == -1){
           index = orbits.length - 1;
         }
         $(orbit).find('.orbit-slide.is-active').removeClass('is-active').css('left', '0%').animate(function(){
           left:'-100%'
         }, 300, function(){
           $(this).css({
             position:'relative',
             display:'none'
           })
         });
         $(orbit).find('.orbit-slide[data-slide='+index+']').addClass('is-active').css({
           position:'relative',
           display:'',
          left:'100%'
         }).animate({
           left:'0'
         }, 300);
       });

  })(jQuery);
});
